var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 46,
    viewBox: "0 0 36 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6486 0.0968213C1.09111 0.24792 0.272088 1.07128 0.122112 1.63115C-0.0407039 2.23963 -0.0407039 43.7176 0.122112 44.3261C0.296715 44.978 1.09827 45.7227 1.78805 45.8739C2.55551 46.042 33.4503 46.042 34.2178 45.8739C34.9075 45.7227 35.7091 44.978 35.8837 44.3261C35.9643 44.0249 35.9991 39.7253 35.9994 29.9958L36 16.0958H28.1598H20.3197L20.2926 8.05689L20.2657 0.0179915L11.1619 0.00196763C5.18814 -0.00867921 1.9173 0.0240141 1.6486 0.0968213ZM24.7387 5.7989V11.579H30.3167C33.3846 11.579 35.8948 11.5425 35.8948 11.4979C35.8948 11.4533 33.3846 8.85229 30.3167 5.71781L24.7387 0.0187443V5.7989ZM25.7065 20.9962C26.1947 21.2491 26.415 21.4668 26.6415 21.9202C26.9445 22.5269 26.9966 23.0988 26.803 23.6944C26.6516 24.16 26.1176 24.7424 21.8183 29.1319C18.5116 32.508 16.8805 34.0998 16.6118 34.2132C16.1262 34.418 15.3709 34.4257 14.9134 34.2304C14.723 34.1491 13.4501 33.1329 12.0847 31.9723C9.37977 29.6729 9.16223 29.409 9.16223 28.4259C9.16223 27.1216 10.0934 26.1713 11.3724 26.1705C11.6975 26.1703 12.0929 26.2454 12.2745 26.3417C12.4522 26.436 13.281 27.0958 14.1163 27.808L15.6349 29.1027L19.5875 25.0672C22.5791 22.013 23.6411 20.9936 23.9552 20.8746C24.4493 20.6874 25.2125 20.7404 25.7065 20.9962Z",
    fill: "url(#paint0_linear_1_128)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_128",
    x1: 18,
    y1: 20.9091,
    x2: 18,
    y2: 51.5758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D1CC",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartContract);
export default __webpack_public_path__ + "static/media/smart-contract.f1ae5757a45f3f8884a17009fef135d5.svg";
export { ForwardRef as ReactComponent };